<template>
  <v-container fluid class="pa-0" style="background: linear-gradient(to bottom, #f2c46d, #3b5d58); min-height: 100vh;">
    <!-- Search Bar -->
    <v-row justify="center" class="mb-6 pt-8">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="searchText"
          label="Search Members"
          outlined
          dense
          rounded
          clearable
          color="primary"
          prepend-inner-icon="mdi-magnify"
          @input="filterMembers"
        />
      </v-col>
    </v-row>

    <!-- Loading Indicator -->
    <v-row justify="center" v-if="isLoading">
      <v-col cols="auto">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>

    <!-- Member List -->
    <v-row justify="center" v-if="!isLoading && filteredMembers.length">
      <v-col
        v-for="user in filteredMembers"
        :key="user.id"
        cols="12"
        md="6"
        lg="4"
        class="mb-6"
      >
        <v-card class="rounded-xl soft-card">
          <v-img
            :src="user.image || defaultImage"
            height="200"
            alt="User Image"
            class="rounded-t-xl"
          ></v-img>
          <v-card-title class="text-h6">{{ user.fullName }}</v-card-title>
          <v-card-subtitle>{{ user.title }}</v-card-subtitle>
          <v-card-actions class="justify-center">
            <v-btn text color="primary" rounded @click="viewUserDetails(user)">
              View Profile
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- No Results -->
    <v-row justify="center" v-if="!isLoading && !filteredMembers.length">
      <v-col cols="auto">
        <p style="color: white;">No members found.</p>
      </v-col>
    </v-row>

    <!-- Tab Bar -->
    <v-bottom-navigation app background-color="#3b5d58" grow dark>
      <v-btn icon to="/home">
        <span>
          <v-icon>mdi-home</v-icon>
          <p class="tab-label">Home</p>
        </span>
      </v-btn>
      <v-btn icon to="/search">
        <span>
          <v-icon>mdi-magnify</v-icon>
          <p class="tab-label">Search</p>
        </span>
      </v-btn>
      <v-btn icon to="/explore">
        <span>
          <v-icon>mdi-compass-outline</v-icon>
          <p class="tab-label">Explore</p>
        </span>
      </v-btn>
      <v-btn icon to="/messages">
        <span>
          <v-icon>mdi-message-text-outline</v-icon>
          <p class="tab-label">Messages</p>
        </span>
      </v-btn>
      <v-btn icon to="/groups">
        <span>
          <v-icon>mdi-account-group</v-icon>
          <p class="tab-label">Groups</p>
        </span>
      </v-btn>
      <v-btn icon @click="$goToProfile()">
  <span>
    <v-icon>mdi-account</v-icon>
    <p class="tab-label">Profile</p>
  </span>
</v-btn>

    </v-bottom-navigation>
  </v-container>
</template>


<script>
import { collection, getDocs } from "firebase/firestore";
import { auth, db } from "@/firebase";

export default {
  name: "SearchView",
  data() {
    return {
      searchText: "",
      members: [],
      filteredMembers: [],
      isLoading: true,
      currentUserId: null,
      defaultImage: "@/assets/default-user.png",
    };
  },
  methods: {
    async fetchMembers() {
      this.isLoading = true;
      try {
        this.currentUserId = auth.currentUser?.uid;
        const membersRef = collection(db, "user"); // ✅ Corrected collection
        const snapshot = await getDocs(membersRef);

        this.members = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        this.filterMembers(); // Apply initial filter
      } catch (error) {
        console.error("Error fetching members:", error);
      } finally {
        this.isLoading = false;
      }
    },
    filterMembers() {
  const searchTextLower = this.searchText.toLowerCase();

  this.filteredMembers = this.members.filter((member) => {
    const isCurrentUser = member.id === this.currentUserId;
    const isAdmin = member.type && member.type.toLowerCase() === "admin";
    const isMinister = member.type && member.type.toLowerCase() === "minister";

    if (isCurrentUser || isAdmin || isMinister) {
      return false; // ❌ Exclude current user, admins, and ministers
    }

    return (
      (member.fullName && member.fullName.toLowerCase().includes(searchTextLower)) ||
      (member.title && member.title.toLowerCase().includes(searchTextLower))
    );
  });
},
viewUserDetails(user) {
  this.$router.push({ name: "MemberDetail", params: { id: user.id, uid: user.uid } });
},
  },
  async mounted() {
    await this.fetchMembers();
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.v-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.15);
}
.soft-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
}
.tab-label {
  font-size: 11px;
  margin-top: 2px;
  color: white;
}
.v-btn {
  font-weight: bold;
  border-radius: 10px;
}
</style>

